import React from 'react'
import { CButton } from '@coreui/react'

const RButtonSuccess = ({ children, type, ...props }) => {
    return <CButton type={type ?? 'button'} size="sm" color='success' {...props}>{children}</CButton>
}

export default RButtonSuccess
